import { BaseDto } from './base.dto';
import { MerchantPrinterDto } from './merchantPrinter.dto';
import { PrintConfigurationDto } from './printConfiguration.dto';

export enum PrintFailureAction {
    MESSAGE_ONLY,
    RETRY
}

export class PrintConfigurationMerchantPrinterDto extends BaseDto{
    
    printConfiguration: PrintConfigurationDto;
    

    merchantPrinter: MerchantPrinterDto;


    copies: number;


    printingWidthOverrideValue?: number;


    printingLineCharacterValue?: string;


    printExpirationTimeMs: number;


    printFailureAction: PrintFailureAction;


    printFailureRetryCount: number;
    

    enabled: boolean;

    allowNotes?: boolean;

}